<template>
  <div class="transfer-in-wrap">
    <div class="panel-card" style="width: 50%; flex-shrink: 0; margin-right: 16px">
      <div class="panel-header">
        <span class="header-item cur">添加类目词</span>
        <!-- <span class="header-item">添加关键词</span> -->
      </div>
      <div class="card-content">
        <div class="input-wrap">
          <el-input suffix-icon="el-icon-search" v-model="searchStr" placeholder="请输入内容"></el-input>
        </div>
        <div class="panel-wrap">
          <el-cascader-panel
            ref="cascaderPanelRef"
            v-model="selectInterest"
            :props="{
              multiple: true,
              value: 'id',
              label: 'name',
              emitPath: false,
            }"
            clearable
            :options="options"
            :show-all-levels="false"
            @change="selectChange"
          ></el-cascader-panel>
        </div>
      </div>
    </div>
    <div class="panel-card">
      <div
        class="panel-header"
        style="display: block; line-height: 42px; text-align: right; padding-right: 16px; cursor: pointer; background: rgba(0, 0, 0, 0.02)"
      >
        <span class="clear" @click="clearData">清除</span>
      </div>
      <div class="card-content">
        <div class="content-header">
          <span class="header-col" style="cursor: pointer">全部<i class="el-icon-arrow-down" style="margin-left: 4px"></i></span>
          <span class="header-col">覆盖人数</span>
        </div>
        <ul class="select-list">
          <li class="select-item" v-for="item of nodeList" :key="item.data.id">
            <span class="item-name">{{ item.data.name }}</span>
            <span class="item-name">{{ item.data.num }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchStr: "",
      selectInterest: [],
      nodeList: [],
    };
  },
  methods: {
    selectChange() {
      let data = this.$refs.cascaderPanelRef.getCheckedNodes(true);
      this.nodeList = data;
      this.$emit("selectChange", data);
    },
    clearData() {
      this.$refs.cascaderPanelRef.clearCheckedNodes();
    },
    getSelectList() {
      return this.nodeList.map((item) => item.data.id);
    },
    setSelectList(data) {
      this.selectInterest = data;
      this.$nextTick(() => {
        this.selectChange();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.transfer-in-wrap {
  min-height: 290px;
  display: flex;
  .panel-card {
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    width: 100%;
    .panel-header {
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      border-bottom: 1px solid rgba(0, 0, 0, 0.15);
      .header-item {
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        border-bottom: 2px solid transparent;
        padding: 10px 0;
        cursor: pointer;
        &.cur {
          color: rgba(24, 144, 255, 1);
          border-bottom: 2px solid rgba(24, 144, 255, 1);
        }
      }
      .clear {
        color: rgba(24, 144, 255, 1);
        font-size: 14px;
        flex: right;
      }
    }
  }
  .card-content {
    .input-wrap {
      padding: 8px;
    }
    .panel-wrap {
      width: 100%;
      overflow-x: auto;
      /deep/ .el-cascader-panel.is-bordered {
        border: none;
      }
    }
    .content-header {
      padding: 10px;
      display: flex;
      justify-content: space-between;
      .header-col {
        color: rgba(0, 0, 0, 0.65);
        font-size: 13px;
      }
    }
    .select-list {
      padding: 0px 10px;
      margin: 0px;
      list-style: none;
      height: 200px;
      overflow: auto;
      .select-item {
        display: flex;
        justify-content: space-between;
        padding: 5px 0;
        .item-name {
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 120px;
        }
      }
    }
  }
}
</style>
